import { useState } from 'react';
export function useNewPassword() {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(prev => !prev);
    };
    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(prev => !prev);
    };
    return {
        showPassword,
        showConfirmPassword,
        toggleShowPassword,
        toggleShowConfirmPassword,
    };
}
